<ng-container>
    <div class="partner-card" role="region" >
        <div class="partner-image-container">
            <div class="partner-image" role="img" attr.aria-label="Image of {{ partner.title }}"></div>
        </div>
        <div class="partner-detail-container">
            <div id="partner-title-{{partner.partnerOfferId}}" class="partner-title" attr.aria-label="{{ partner.title }}">
                {{ partner.title }}
            </div>
            <div class="partner-subtitle mt-2" attr.aria-label="{{ partner.subTitle }}">
                {{ partner.subTitle }}
            </div>
            <div class="redeemed-button-container" *ngIf="partner.isOfferRedeemed">
                <div class="redeemed-button-display">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9801 3.37307C14.2983 3.63824 14.3413 4.11117 14.0762 4.42938L6.57617 13.4294C6.44127 13.5913 6.24449 13.6889 6.03399 13.6985C5.82348 13.708 5.61867 13.6286 5.46967 13.4796L1.46967 9.47961C1.17678 9.18672 1.17678 8.71185 1.46967 8.41895C1.76256 8.12606 2.23743 8.12605 2.53033 8.41895L5.9496 11.8382L12.9238 3.4691C13.189 3.15089 13.6619 3.1079 13.9801 3.37307Z" fill="#C2C1C0"/>
                    </svg>
                    <button class="redeemed-button-display" disabled="disabled" attr.aria-label="{{ partner.title }} {{ partner.ctaText }}">
                        Redeemed
                    </button>
                </div>
            </div>
            <div *ngIf="!partner.isOfferRedeemed">
                <ng-container *ngIf="partner.enableCta">
                    <div class="button-container">
                        <button *ngIf="!partner.isOfferRedeemed" (click)="openPartnerDetailPage($event)" (keypress)="openPartnerDetailPage($event)" class="button-display" attr.aria-label="{{ partner.ctaText }} for {{ partner.title }}">
                            {{ partner.ctaText }}
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="!partner.enableCta">
                    <div class="redeemed-button-container">
                        <div class="redeemed-button-display">
                            <button disabled="disabled" *ngIf="!partner.isOfferRedeemed" (click)="openPartnerDetailPage($event)" (keypress)="openPartnerDetailPage($event)" class="redeemed-button-display" attr.aria-label="{{ partner.ctaText }} for {{ partner.title }} disabled">
                                {{ partner.ctaText }}
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>

